import { toRouteTemplate } from './routeTemplate';

export type BeforeTrackOptions = {
  environment: string;
  app: string;
  getPathname: () => string;
};

/**
 * Builds the hook that stamps `app`, `environment` and `page` onto every
 * captured event.
 *
 * These cannot be registered as super properties: the SDK emits the first page
 * view synchronously inside `init`, before any of the app's React code runs, so
 * a property registered later would be missing from it. The hook runs on every
 * event including that first one.
 *
 * `page` is read here rather than from a router subscription because the SDK
 * emits its page view synchronously from inside the patched `history.pushState`
 * — a React effect always runs after, and would report the previous route.
 */
export const buildBeforeTrack =
  ({ app, environment, getPathname }: BeforeTrackOptions) =>
  (eventName: string, properties: Record<string, unknown>): [string, Record<string, unknown>] => [
    eventName,
    { ...properties, app, environment, page: toRouteTemplate(getPathname()) },
  ];
